const styles = {
  container: {
    fontSize: 18,
    fontWeight: 400,
    padding: "0 10px",
    textAlign: "center"
  }
};

export default styles;
